<svelte:head>

    <title>Mitglied Detail • Ämtler-Bon Admin</title>

</svelte:head>

<script context="module">

    let memberId;

    export let preload = async ({ params }) => {

        const { memberid } = params;

        memberId = memberid;

    };

</script>

<script>

    import SessionManager from "../components/utils/session.svelte";
    import MemberDetail from "../components/screens/member.svelte";

</script>

<SessionManager />

<section>

    <MemberDetail memberId={memberId} />

</section>


<style>

    section {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: flex-start;
        height: inherit;
        margin-left: 31vh;
    }

</style>